module.exports = __webpack_public_path__ + "media/JackpotPanStart.359b4f46.wav";